/** PURE_IMPORTS_START .._operators_retryWhen PURE_IMPORTS_END */
import { retryWhen as higherOrder } from '../operators/retryWhen';
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
export function retryWhen(notifier) {
    return higherOrder(notifier)(this);
}
//# sourceMappingURL=retryWhen.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/retryWhen.js
// module id = 848
// module chunks = 0